import Vue from 'vue';
import App from './App.vue';
import 'ant-design-vue/dist/antd.less';
import VueCurrencyInput from 'vue-currency-input';
import SvgIcon from 'vue-svgicon';
import 'vue-loaders/dist/vue-loaders.css';
import VueLoaders from 'vue-loaders';
import WizardSteps from '@/components/WizardSteps';
import NewOrderSidebar from '@/components/NewOrderSidebar';
import TelephoneCta from '@/components/telephone-cta';
import Offer from '@/components/Offer';
import ContactInfoForm from '@/components/ContactInfoForm';
import AddItemWidget from '@/components/AddItemWidget.vue';
import InstrumentInfoForm from '@/components/InstrumentInfoForm.vue';
import SurveyForm from '@/components/SurveyForm.vue';
import OfferFeedback from '@/components/OfferFeedback.vue';
import ReadonlyBanner from '@/components/ReadonlyBanner.vue';
import WizardPageHeader from '@/components/WizardPageHeader.vue';
import EuroValue from '@/components/EuroValue.vue';
import AddInstrumentMobileBtn from '@/components/AddInstrumentMobileBtn.vue';
import Trend from 'vuetrend';
import ScalapayLogo from '@/components/ScalapayLogo.vue';
import CompanyCoverages from '@/components/CompanyCoverages.vue';

import VueClipboard from 'vue-clipboard2';

import * as Sentry from '@sentry/vue';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_I4M_ENV,
  });
}

import {
  DatePicker,
  Input,
  Layout,
  Icon,
  Alert,
  Card,
  Modal,
  Button,
  Select,
  Row,
  Col,
  Checkbox,
  Steps,
  Timeline,
  Drawer,
  Divider,
  Table,
  Tag,
  Tooltip,
  Popconfirm,
  Popover,
  Radio,
  Spin,
  Form,
  FormModel,
  Badge,
  Tabs,
  message,
  notification,
  Statistic,
  Collapse,
} from 'ant-design-vue';

Vue.use(DatePicker);
Vue.use(Tabs);
Vue.use(Badge);
Vue.use(Input);
Vue.use(Layout);
Vue.use(Icon);
Vue.use(Card);
Vue.use(Modal);
Vue.use(Alert);
Vue.use(Button);
Vue.use(Select);
Vue.use(Form);
Vue.use(FormModel);
Vue.use(Col);
Vue.use(Row);
Vue.use(Steps);
Vue.use(Checkbox);
Vue.use(Timeline);
Vue.use(Drawer);
Vue.use(Table);
Vue.use(Tag);
Vue.use(Tooltip);
Vue.use(Popover);
Vue.use(Popconfirm);
Vue.use(Radio);
Vue.use(Spin);
Vue.use(Divider);
Vue.use(Statistic);
Vue.use(Collapse);
Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$info = Modal.info;
Vue.prototype.$success = Modal.success;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$destroyAll = Modal.destroyAll;

require('@uppy/core/dist/style.css');
require('@uppy/status-bar/dist/style.css');
require('@uppy/drag-drop/dist/style.css');

const vMediaQuery = require('v-media-query');

import './style.scss';
import './style.css';
Vue.config.productionTip = false;

Vue.use(VueLoaders);
Vue.use(Trend);
Vue.use(vMediaQuery.default);
Vue.use(VueCurrencyInput, {
  globalOptions: { currency: 'EUR', locale: 'it' },
});

Vue.use(SvgIcon, {
  tagName: 'svgicon',
});

Vue.use(VueClipboard);

Vue.component('wizard-steps', WizardSteps);
Vue.component('new-order-sidebar', NewOrderSidebar);
Vue.component('telephone-cta', TelephoneCta);
Vue.component('telephone-cta', TelephoneCta);
Vue.component('offer', Offer);
Vue.component('contact-info-form', ContactInfoForm);
Vue.component('add-item-widget', AddItemWidget);
Vue.component('instrument-info-form', InstrumentInfoForm);
Vue.component('survey-form', SurveyForm);
Vue.component('offer-feedback', OfferFeedback);
Vue.component('readonly-banner', ReadonlyBanner);
Vue.component('wizard-page-header', WizardPageHeader);
Vue.component('euro-value', EuroValue);
Vue.component('add-instrument-mobile-btn', AddInstrumentMobileBtn);
Vue.component('scalapay-logo', ScalapayLogo);
Vue.component('company-coverages', CompanyCoverages);

// Vue.use(Loading);

import router from './router';
import store from './store';
import i18n from './i18n';

Vue.config.productionTip = false;

import VueGtm from 'vue-gtm';
Vue.use(VueGtm, {
  vueRouter: router, // <-- router instance
  id: process.env.VUE_APP_GTM_ID,
  enabled: process.env.NODE_ENV === 'production',
  debug: process.env.NODE_ENV !== 'production',
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
